// Compare two findings lists by exact canonical JSON (key-order independent).
// Added = in B but not A; Removed = in A but not B; common = count present in both.

function canonical(v: unknown): string {
  const norm = (x: unknown): unknown => {
    if (Array.isArray(x)) return x.map(norm)
    if (x && typeof x === 'object') {
      return Object.fromEntries(
        Object.keys(x as object)
          .sort()
          .map((k) => [k, norm((x as Record<string, unknown>)[k])]),
      )
    }
    return x
  }
  return JSON.stringify(norm(v))
}

export type FindingsDiff = { added: unknown[]; removed: unknown[]; common: number }

export function diffFindings(a: unknown[], b: unknown[]): FindingsDiff {
  const ca = a.map((x) => [canonical(x), x] as const)
  const cb = b.map((x) => [canonical(x), x] as const)
  const setA = new Set(ca.map(([c]) => c))
  const setB = new Set(cb.map(([c]) => c))
  return {
    added: cb.filter(([c]) => !setA.has(c)).map(([, x]) => x),
    removed: ca.filter(([c]) => !setB.has(c)).map(([, x]) => x),
    common: ca.filter(([c]) => setB.has(c)).length,
  }
}
